import { createApi } from '@reduxjs/toolkit/query/react'

import { HttpMethod } from '@/constants/utils'
import { customFetchBaseQuery } from '@/utils/api'
import type {
  SendAppNotificationPayload,
  SendAppNotificationResponse,
} from './interfaces'

export const emailiniumApi = createApi({
  reducerPath: 'emailiniumApi',
  baseQuery: customFetchBaseQuery({
    baseUrl: process.env.GATSBY_EMAILINIUM_URL,
  }),
  endpoints: ({ mutation }) => ({
    sendAppNotification: mutation<
      SendAppNotificationResponse,
      SendAppNotificationPayload
    >({
      query: (payload) => ({
        path: '/awaiting_apps',
        method: HttpMethod.POST,
        body: payload,
      }),
    }),
  }),
})

export const {
  reducer,
  reducerPath,
  middleware,
  useSendAppNotificationMutation,
} = emailiniumApi
